

const getCookieBannerOutcome = (cookies) => {
    if (!window?.cookieBannerInitialized || (!cookies.get('accepted_cookies') && !window?.noCookieConfirmationNeeded)) {
		return null
	}

    // Nuxt returns boolean values for cookies
    const functionalAllowed = cookies.get('functional_cookies') || window?.noCookieConfirmationNeeded
    const performanceAllowed = cookies.get('performance_cookies') || window?.noCookieConfirmationNeeded
    const targetingAllowed = cookies.get('targeting_cookies')  || window?.noCookieConfirmationNeeded

    return {functionalAllowed, performanceAllowed, targetingAllowed}
}

export default function ({ $config, $cookies }, inject) {
    let performanceAllowed = null
    let targetingAllowed = null
    let functionalAllowed = null
    
    // Only run on client-side
    if (process.client) {
        // Set default configuration
        window.stanCookieBannerConfig = {
            colors: {
				'button-border': '#00106d',
				'banner-background': '#ffffff',
				'button-background': '#ffffff',
				'text-primary': '#131f60',
				'button-text': '#ffffff',
				'modal-background': '#ffffff',
				'border-color': '#f2f4f8',
				'toggle-background': '#b5c2d5',
				'toggle-active': '#6355ff',
				'toggle-disabled': '#b5bcff',
			},
            'cookie-policy-url': 'https://terms.stan.store/privacy',
            'cookie-terms-url': 'https://terms.stan.store/terms',
        }

        // Load the cookie banner script
        const script = document.createElement('script')
        window.stanAnalyticsApiUrl = process.env.analytics_api_url
        script.src = $config.cookieBannerUrl
        script.async = true
        script.onload = () => {
            // Initialize cookie banner after script loads
            if (window.CookieBanner) {
                setTimeout(() => {
                    new CookieBanner()
                }, 1000)
            }
        }
        
        // Add event listeners for modal behavior
        document.addEventListener('cookie-modal-shown', () => {
            document.documentElement.style.overflow = 'hidden'
        })
        document.addEventListener('cookie-modal-hidden', () => {
            document.documentElement.style.overflow = ''
        })
        
        document.head.appendChild(script)
        
        // The following code will listen and check for cookie banner being initalized and set/emit events accoridngly
        const awaitCookieBannerOutcome = setInterval(() => {
            const outcome = getCookieBannerOutcome($cookies)
            if (outcome) {
                clearInterval(awaitCookieBannerOutcome)
                performanceAllowed = outcome.performanceAllowed
                targetingAllowed = outcome.targetingAllowed
                functionalAllowed = outcome.functionalAllowed
                document.dispatchEvent(new Event('cookie-banner-processed'))
            }
        }, 500)



    }

    inject('isPerformanceAllowed', () => performanceAllowed)
    inject('isTargetingAllowed', () => targetingAllowed)
    inject('isFunctionalAllowed', () => functionalAllowed)
}
